import axios from 'axios';
export { default as axios } from 'axios';

var e$1=Symbol("cache-parser");function a(e){return ("string"==typeof e||"number"==typeof e)&&(e=Number(e))>=0&&e<Infinity}function r$2(e){return !0===e||"number"==typeof e||"string"==typeof e&&"false"!==e}var t$1=Number;function s$1(s){var n=Object.defineProperty({},e$1,{enumerable:!1,value:1});if(!s||"string"!=typeof s)return n;var i=function(e){var a={},r=e.toLowerCase().replace(/\s+/g,"").split(",");for(var t in r){var s,n=r[t].split("=",2);a[n[0]]=null==(s=n[1])||s;}return a}(s),u=i["max-age"],l=i["max-stale"],o=i["min-fresh"],m=i["s-maxage"],p=i["stale-if-error"],h=i["stale-while-revalidate"];return r$2(i.immutable)&&(n.immutable=!0),a(u)&&(n.maxAge=t$1(u)),a(l)&&(n.maxStale=t$1(l)),a(o)&&(n.minFresh=t$1(o)),r$2(i["must-revalidate"])&&(n.mustRevalidate=!0),r$2(i["must-understand"])&&(n.mustUnderstand=!0),r$2(i["no-cache"])&&(n.noCache=!0),r$2(i["no-store"])&&(n.noStore=!0),r$2(i["no-transform"])&&(n.noTransform=!0),r$2(i["only-if-cached"])&&(n.onlyIfCached=!0),r$2(i.private)&&(n.private=!0),r$2(i["proxy-revalidate"])&&(n.proxyRevalidate=!0),r$2(i.public)&&(n.public=!0),a(m)&&(n.sMaxAge=t$1(m)),a(p)&&(n.staleIfError=t$1(p)),a(h)&&(n.staleWhileRevalidate=t$1(h)),n}

var r$1=Symbol();function e(){var e,n,o=new Promise(function(r,o){e=r,n=o;});return o.resolve=e,o.reject=n,o[r$1]=1,o}

function t(n,e){void 0===e&&(e=new WeakMap);var r=typeof n;if(n&&"object"===r&&!(n instanceof Date||n instanceof RegExp)){for(var o=Array.isArray(n)?[]:{},i=Object.keys(n).sort(function(t,n){return t>n?1:-1}),a=i.length;a--;){var f=i[a],c=n[f];if("object"==typeof c&&null!==c&&!(c instanceof Date||c instanceof RegExp)){if(e.has(c))continue;e.set(c,!0);}o[f]=t(c,e);}return String(n.constructor)+JSON.stringify(o,i)}return r+String(n)}function n$1(n){n=t(n);for(var e=5381,r=0;r<n.length;)e=33*e^n.charCodeAt(r++);return e}

/*!
 * Axios Cache Interceptor v1.3.1
 * (c) 2021-present Arthur Fiorette & Contributors
 * Released under the MIT License.
 */
var r={d:(e,t)=>{for(var a in t)r.o(t,a)&&!r.o(e,a)&&Object.defineProperty(e,a,{enumerable:!0,get:t[a]});},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t)},s={};r.d(s,{h4:()=>i,UN:()=>A,uu:()=>x,Kd:()=>I,ZF:()=>T,nv:()=>y,p:()=>f,E7:()=>d,NQ:()=>n,xK:()=>E,G6:()=>h,LN:()=>v,Bw:()=>S,Ad:()=>u,$k:()=>m,v8:()=>O,Jk:()=>g,tI:()=>p,iS:()=>l});const o=(e=>{var t={};return r.d(t,e),t})({parse:()=>s$1}),i=Object.freeze({IfModifiedSince:"if-modified-since",LastModified:"last-modified",IfNoneMatch:"if-none-match",CacheControl:"cache-control",Pragma:"pragma",ETag:"etag",Expires:"expires",Age:"age",XAxiosCacheEtag:"x-axios-cache-etag",XAxiosCacheLastModified:"x-axios-cache-last-modified",XAxiosCacheStaleIfError:"x-axios-cache-stale-if-error"}),n=e=>{if(!e)return "not enough headers";const t=e[i.CacheControl];if(t){const{noCache:a,noStore:r,maxAge:s,maxStale:n,immutable:c,staleWhileRevalidate:d}=(0, o.parse)(String(t));if(a||r)return "dont cache";if(c)return {cache:31536e6};if(void 0!==s){const t=e[i.Age];return {cache:t?1e3*(s-Number(t)):1e3*s,stale:void 0!==n?1e3*n:void 0!==d?1e3*d:void 0}}}const a=e[i.Expires];if(a){const e=Date.parse(String(a))-Date.now();return e>=0?{cache:e}:"dont cache"}return "not enough headers"};const c=(e=>{var t={};return r.d(t,e),t})({deferred:()=>e});function d(e){return e?t=>e(t)||304===t:e=>e>=200&&e<300||304===e}function u(e="get",t=[]){return e=e.toLowerCase(),t.some((t=>t===e))}function l(e,t){var a;t.headers||(t.headers={});const{etag:r,modifiedSince:s}=t.cache;if(r){const s=!0===r?null===(a=e.data)||void 0===a?void 0:a.headers[i.ETag]:r;s&&(t.headers[i.IfNoneMatch]=s);}s&&(t.headers[i.IfModifiedSince]=!0===s?e.data.headers[i.LastModified]||new Date(e.createdAt).toUTCString():s.toUTCString());}function f(e,t){return 304===e.status&&t?(e.cached=!0,e.data=t.data,e.status=t.status,e.statusText=t.statusText,e.headers=Object.assign(Object.assign({},t.headers),e.headers),t):{data:e.data,status:e.status,statusText:e.statusText,headers:e.headers}}function h(e){const t=async a=>{var r,s,o,n,f,h,g,p,v,m,w,y,S,I,x;if(a.id=e.generateKey(a),!1===a.cache)return a;if(a.cache=Object.assign(Object.assign({},e.defaults.cache),a.cache),a.cache.cacheTakeover&&(null!==(r=(m=a.headers)[w=i.CacheControl])&&void 0!==r||(m[w]="no-cache"),null!==(s=(y=a.headers)[S=i.Pragma])&&void 0!==s||(y[S]="no-cache"),null!==(o=(I=a.headers)[x=i.Expires])&&void 0!==o||(I[x]="0")),!u(a.method,a.cache.methods))return a;let C=await e.storage.get(a.id,a);const b=a.cache.override;e:if("empty"===C.state||"stale"===C.state||b){if(e.waiting[a.id]&&!b&&(C=await e.storage.get(a.id,a),"empty"!==C.state)){break e}return e.waiting[a.id]=(0, c.deferred)(),e.waiting[a.id].catch((()=>{})),await e.storage.set(a.id,{state:"loading",previous:b?C.data?"stale":"empty":C.state,data:C.data,createdAt:b&&!C.createdAt?Date.now():C.createdAt},a),"stale"===C.state&&l(C,a),a.validateStatus=d(a.validateStatus),("stale"===C.state||C.data)&&await(null===(f=(n=a.cache).hydrate)||void 0===f?void 0:f.call(n,C)),a}let A;if("loading"===C.state){const r=e.waiting[a.id];if(!r)return C.data&&await(null===(g=(h=a.cache).hydrate)||void 0===g?void 0:g.call(h,C)),a;try{A=await r;}catch(e){return C.data&&await(null===(v=(p=a.cache).hydrate)||void 0===v?void 0:v.call(p,C)),t(a)}}else A=C.data;return a.adapter=function(){return Promise.resolve({config:a,data:A.data,headers:A.headers,status:A.status,statusText:A.statusText,cached:!0,id:a.id})},a};return {onFulfilled:t,apply:()=>e.interceptors.request.use(t)}}async function g(e,t){var a;if("function"==typeof t)return t(e);const{statusCheck:r,responseMatch:s,containsHeaders:o}=t;if(r&&!await r(e.status)||s&&!await s(e))return !1;if(o)for(const[t,r]of Object.entries(o))if(!await r(null!==(a=e.headers[t.toLowerCase()])&&void 0!==a?a:e.headers[t]))return !1;return !0}async function p(e,t,a){if("function"==typeof a)return a(t);for(const[r,s]of Object.entries(a)){if("delete"===s){await e.remove(r,t.config);continue}const a=await e.get(r,t.config);if("loading"===a.state)continue;const o=await s(a,t);"delete"!==o?"ignore"!==o&&await e.set(r,o,t.config):await e.remove(r,t.config);}}function v(e){const t=async(t,a)=>{var r;await e.storage.remove(t,a),null===(r=e.waiting[t])||void 0===r||r.reject(),delete e.waiting[t];},a=async a=>{var r;if(!(null==a?void 0:a.config))throw a;a.id=a.config.id,null!==(r=a.cached)&&void 0!==r||(a.cached=!1);const s=a.config,o=s.cache;if(a.cached)return a;if(!o)return a.cached=!1,a;if(o.update&&await p(e.storage,a,o.update),!u(s.method,o.methods))return a;const n=await e.storage.get(a.id,s);if("loading"!==n.state)return a;if(!n.data&&!await g(a,o.cachePredicate))return await t(a.id,s),a;for(const e of Object.keys(a.headers))e.startsWith("x-axios-cache")&&delete a.headers[e];o.etag&&!0!==o.etag&&(a.headers[i.XAxiosCacheEtag]=o.etag),o.modifiedSince&&(a.headers[i.XAxiosCacheLastModified]=!0===o.modifiedSince?"use-cache-timestamp":o.modifiedSince.toUTCString());let c,d=o.ttl||-1;if(o.interpretHeader){const r=e.headerInterpreter(a.headers);if("dont cache"===r)return await t(a.id,s),a;"not enough headers"!==r&&("number"==typeof r?d=r:(d=r.cache,c=r.stale));}const l=f(a,n.data);"function"==typeof d&&(d=await d(a)),o.staleIfError&&(a.headers[i.XAxiosCacheStaleIfError]=String(d));const h={state:"cached",ttl:d,staleTtl:c,createdAt:Date.now(),data:l},v=e.waiting[a.id];return v&&(v.resolve(h.data),delete e.waiting[a.id]),await e.storage.set(a.id,h,s),a},r=async a=>{var r;if(!a.isAxiosError||!a.config)throw a;const s=a.config,n=s.id,c=s.cache,d=a.response;if(!c||!n)throw a;if(!u(s.method,c.methods))throw await t(n,s),a;const l=await e.storage.get(n,s);if("loading"!==l.state||"stale"!==l.previous)throw await t(n,s),a;if(c.staleIfError){const t=String(null==d?void 0:d.headers[i.CacheControl]),u=t&&(0, o.parse)(t).staleIfError,f="function"==typeof c.staleIfError?await c.staleIfError(d,l,a):!0===c.staleIfError&&u?1e3*u:c.staleIfError;if(!0===f||"number"==typeof f&&l.createdAt+f>Date.now())return null===(r=e.waiting[n])||void 0===r||r.resolve(l.data),delete e.waiting[n],await e.storage.set(n,{state:"stale",createdAt:Date.now(),data:l.data},s),{cached:!0,config:s,id:n,data:l.data.data,headers:l.data.headers,status:l.data.status,statusText:l.data.statusText}}throw await t(n,s),a};return {onFulfilled:a,onRejected:r,apply:()=>e.interceptors.response.use(a,r)}}const m=e=>!!e&&!!e["is-storage"];function w(e){const t=e.data.headers;return i.ETag in t||i.LastModified in t||i.XAxiosCacheEtag in t||i.XAxiosCacheLastModified in t}function y(e){return !String(e.data.headers[i.CacheControl]).includes("must-revalidate")&&(!!w(e)||"cached"===e.state&&void 0!==e.staleTtl&&Math.abs(Date.now()-(e.createdAt+e.ttl))<=e.staleTtl)}function S(e){return void 0!==e.ttl&&e.createdAt+e.ttl<=Date.now()}function I({set:e,find:t,remove:a}){return {"is-storage":1,set:e,remove:a,get:async(r,s)=>{let o=await t(r,s);if(!o)return {state:"empty"};if("empty"===o.state||"loading"===o.state)return o;if("cached"===o.state){if(!S(o))return o;if(!y(o))return await a(r,s),{state:"empty"};o={state:"stale",createdAt:o.createdAt,data:o.data,ttl:void 0!==o.staleTtl?o.staleTtl+o.ttl:void 0},await e(r,o,s);}return S(o)?w(o)?o:(await a(r,s),{state:"empty"}):o}}}function x(e=!1,t=!1,a=!1){const r=I({set:(t,s)=>{if(a){let e=Object.keys(r.data);if(e.length>=a)for(r.cleanup(),e=Object.keys(r.data);e.length>=a;)delete r.data[e.shift()];}r.data[t]="double"===e?"function"==typeof structuredClone?structuredClone(s):JSON.parse(JSON.stringify(s)):s;},remove:e=>{delete r.data[e];},find:t=>{const a=r.data[t];return e&&void 0!==a?"function"==typeof structuredClone?structuredClone(a):JSON.parse(JSON.stringify(a)):a}});return r.data=Object.create(null),r.cleanup=()=>{const e=Object.keys(r.data);let t,a,s=-1;for(;++s<e.length;)a=e[s],t=r.data[a],"empty"!==t.state?"cached"===t.state&&S(t)&&!y(t)&&r.remove(a):r.remove(a);},t&&(r.cleaner=setInterval(r.cleanup,t)),r}const C=(e=>{var t={};return r.d(t,e),t})({hash:()=>n$1}),b=/^\/|\/$/g;function A(e){return t=>{if(t.id)return t.id;const a=e(t);return "string"==typeof a||"number"==typeof a?`${a}`:`${(0, C.hash)(a)}`}}const E=A((({baseURL:e="",url:t="",method:a="get",params:r,data:s})=>(e&&(e=e.replace(b,"")),t&&(t=t.replace(b,"")),a&&(a=a.toLowerCase()),{url:e+(e&&t?"/":"")+t,params:r,method:a,data:s})));function O(e,t={}){var a,r,s,o,i,c;const d=e;if(d.defaults.cache)throw new Error("setupCache() should be called only once");if(d.storage=t.storage||x(),!m(d.storage))throw new Error("Use buildStorage() function");return d.waiting=t.waiting||{},d.generateKey=t.generateKey||E,d.headerInterpreter=t.headerInterpreter||n,d.requestInterceptor=t.requestInterceptor||h(d),d.responseInterceptor=t.responseInterceptor||v(d),d.debug=t.debug||function(){},d.defaults.cache={update:t.update||{},ttl:null!==(a=t.ttl)&&void 0!==a?a:3e5,methods:t.methods||["get","head"],cachePredicate:t.cachePredicate||{statusCheck:e=>[200,203,300,301,302,404,405,410,414,501].includes(e)},etag:null===(r=t.etag)||void 0===r||r,modifiedSince:null!==(s=t.modifiedSince)&&void 0!==s?s:!1===t.etag,interpretHeader:null===(o=t.interpretHeader)||void 0===o||o,cacheTakeover:null===(i=t.cacheTakeover)||void 0===i||i,staleIfError:null===(c=t.staleIfError)||void 0===c||c,override:!1,hydrate:void 0},d.requestInterceptor.apply(),d.responseInterceptor.apply(),d}function T(e,t="axios-cache-"){return I({find:a=>{const r=e.getItem(t+a);return r?JSON.parse(r):void 0},remove:a=>{e.removeItem(t+a);},set:(a,r)=>{const s=()=>e.setItem(t+a,JSON.stringify(r));try{return s()}catch(r){const o=Object.entries(e).filter((e=>e[0].startsWith(t))).map((e=>[e[0],JSON.parse(e[1])]));for(const t of o)"cached"===t[1].state&&S(t[1])&&!y(t[1])&&e.removeItem(t[0]);try{return s()}catch(t){const a=o.sort(((e,t)=>(e[1].createdAt||0)-(t[1].createdAt||0)));for(const t of a){e.removeItem(t[0]);try{return s()}catch(e){}}}e.removeItem(t+a);}}})}s.h4;s.UN;s.uu;var M=s.Kd;s.ZF;s.nv;s.p;s.E7;s.NQ;s.xK;s.G6;s.LN;s.Bw;s.Ad;s.$k;var F=s.v8;s.Jk;s.tI;s.iS;

const getIndexedDB = () => {
  return typeof window !== "undefined" && window ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : void 0;
};
const connectIDB = (cacheDBName) => {
  return new Promise(
    (resolve, reject) => {
      const indexedDB = getIndexedDB();
      if (!indexedDB)
        reject();
      if (indexedDB) {
        const request = indexedDB.open(cacheDBName, 1);
        let db;
        request.onupgradeneeded = function(event) {
          db = event.target.result;
          resolve(db);
        };
        request.onsuccess = function(event) {
          db = event.target.result;
          resolve(db);
        };
      }
    }
  );
};
const getIDBByKey = (db, storeName, key) => {
  return new Promise((resolve) => {
    const store = getIDBStore(db, storeName);
    const request = store.get(key);
    request.onsuccess = function(event) {
      resolve(event.target.result);
    };
  });
};
const getIDBStore = (db, storeName) => {
  let store;
  if (!db.objectStoreNames.contains(storeName)) {
    store = db.createObjectStore(storeName, {
      autoIncrement: true
    });
    store.createIndex("url", "url");
    store.createIndex("createdAt", "createdAt");
    store.createIndex("ttl", "ttl");
  } else {
    const txn = db.transaction(storeName, "readwrite");
    store = txn.objectStore(storeName);
  }
  return store;
};
const setDataToStore = (db, tableName, key, value) => {
  return new Promise((resolve, reject) => {
    const store = getIDBStore(db, tableName);
    const request = store.put({ ...value }, key);
    request.onsuccess = (e) => {
      const targer = e.target;
      resolve(targer.result);
      db.close();
    };
    request.onerror = () => {
      reject();
    };
  });
};
const getAllIndexDb = (db, storeName) => {
  return new Promise((resolve) => {
    const store = getIDBStore(db, storeName);
    const request = store.getAll();
    request.onsuccess = async (event) => {
      const data = event.target.result;
      resolve(data);
    };
  });
};

const setupIDBCache = (axiosInstance, cacheDBName, tableName) => {
  return F(axiosInstance, {
    storage: M({
      async find(key) {
        const db = await connectIDB(cacheDBName);
        return await getIDBByKey(db, tableName, key);
      },
      async set(key, value, currentRequest) {
        const db = await connectIDB(cacheDBName);
        delete value.staleTtl;
        const valueTableKey = {
          id: key,
          url: currentRequest?.url,
          ...value
        };
        await setDataToStore(db, tableName, key, valueTableKey);
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      async remove() {
      }
    }),
    cacheTakeover: false
  });
};
function useCacheRequest(cacheDBName, tableName) {
  const axiosInstance = axios.create();
  const axiosInstanceNoAuth = axios.create();
  if (typeof window !== "undefined" && window) {
    window.getIndexDBList = async () => {
      const db = await connectIDB(cacheDBName);
      const data = await getAllIndexDb(db, tableName);
      if (!db) {
        console.log("IndexedDB does not exist in this environment!");
      } else {
        console.log(data);
      }
    };
  }
  return {
    axiosCache: setupIDBCache(axiosInstance, cacheDBName, tableName),
    axiosCacheNoAuth: setupIDBCache(axiosInstanceNoAuth, cacheDBName, tableName),
    axiosInstance,
    axiosInstanceNoAuth
  };
}

const COOKIE_KEYS = {
  ACCESS_TOKEN: "SUAT",
  ACCESS_EXPIRED_CHECK: "SUAT_EXPIRED_CHECK",
  REFRESH_TOKEN: "SURT",
  SDK_ACCESS_TOKEN: "authorization",
  SDK_REFRESH_TOKEN: "authorizationr",
  // (구) 토큰
  HEADER: "HD",
  PAYLOAD: "PLD",
  SIGN: "SIGN",
  OLD_REFRESH_TOKEN: "RFT",
  FOREVER: "FOREVER",
  LOCALE: "LOCALE",
  LANGUAGE: "PRM",
  NNTO: "NNTO",
  COUNTRY: "NNTO",
  TIMEZONE: "TZ",
  UTC_OFFSET: "TZ_OFFSET",
  COVERAGES: "COVERAGES",
  UUID: "sgs_da_uuid",
  ISSDK: "ISSDK",
  REGULATION: "REGULATION",
  COOKIE_DOMAIN: ".onstove.com",
  SGMC: "SGMC"
};
const DEFAULT_CHECK_REFRESH_TOKEN = true;
const DEFAULT_SUAT_EXPIRED_CHECK = "Y";
const DEAUTL_EXPIRES_TIME_SURT = 7;

const DependencyInjectId = {
  /** Key for Nuxt service injection provider **/
  ContextCore: "SeedCoreContext"
};

const ErrorCode = {
  INVALID_TOKEN: 401
};

const FormatResponse = {
  Custom: "custom",
  Default: "default",
  Member: "member",
  Other: "other"
};

const GlobalDomain = {
  DEFAULT_LANGUAGE: "ko",
  DEFAULT_COUNTRY: "KR",
  DEFAULT_TIMEZONE: "Asia/Seoul",
  DEFAULT_UTC_OFFSET: 540,
  DEFAULT_LOCALE: "ko",
  DEFAULT_REGULATION: "KOREA",
  DEFAULT_COVERAGES: ["de", "en", "es", "fr", "ja", "ko", "pt", "zh-tw"],
  DEFAULT_NATION: "KR"
};

const ServiceKey = {
  AuthService: "AuthService",
  AxiosService: "AxiosService",
  GdService: "GdService",
  ConfigurationService: "ConfigurationService"
};

const renew = async (axiosService, request, config) => {
  const { post } = axiosService;
  const dataPost = `refresh_token=${request.refresh_token}&properties=${request.properties}`;
  const { data } = await post(`${config.SESSION_URL}/v1.0/common/renew`, {
    method: "post",
    data: dataPost,
    isAuth: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
  return data?.data || null;
};
const getMember = async (axiosService, request, config) => {
  const { get } = axiosService;
  const queryData = {
    properties: request.properties || ""
  };
  const { data } = await get(
    `${config.API_URL}/member/v1.1?${new URLSearchParams(queryData).toString()}`,
    {
      isAuth: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      formatResponse: FormatResponse.Member
    }
  );
  return data?.data || null;
};

const createAuthLink = function(URL, { redirectCurrentPage, params }) {
  const copyParams = !isEmptyObject(params) ? structuredClone(params) : "";
  let currentUrl = `redirect_url=${encodeURIComponent(window.location.href)}`;
  let redirectURL = redirectCurrentPage ? currentUrl : "";
  if (copyParams) {
    if (copyParams.redirect_url) {
      currentUrl = redirectURL = `redirect_url=${params.redirect_url}`;
      delete copyParams.redirect_url;
    }
  }
  const paramToQuery = !isEmptyObject(params) ? `${queryString(copyParams)}` : "";
  redirectURL = `${redirectURL}&${paramToQuery}`;
  if (isCP(paramToQuery)) {
    redirectURL = `${currentUrl}&${paramToQuery}`;
  }
  return `${URL}${redirectURL}`;
};
const isEmptyObject = function(obj = {}) {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop))
      return false;
  }
  return Object.keys(obj || {}).length === 0;
};
const queryString = (obj) => {
  if (typeof obj === "string") {
    return "";
  }
  return Object.keys(obj).map(
    (k) => encodeURIComponent(k) + "=" + encodeURIComponent(obj[k])
  ).join("&");
};
const isCP = function(loginParams) {
  if (loginParams) {
    return loginParams.indexOf("inflow_path=CP_PAGE") > -1;
  }
  return false;
};
const goLogin = async (params, redirectCurrentPage = true, config) => {
  window.location = createAuthLink(`${config.AUTH_URL}/login?`, {
    redirectCurrentPage,
    params
  });
};
const goLogout = (redirectUrl, config) => {
  window.location.href = `${config.MEMBER_URL}/auth/logout?redirect_url=${redirectUrl}`;
};

const TIME_CONFIG = {
  /** Number of seconds in a day */
  SECONDS_IN_DAY: 24 * 60 * 60 * 1e3
};

const isBrowser = () => {
  return typeof window !== "undefined" && typeof self !== "undefined";
};
const getCookie = (cookieName, defaultValue) => {
  if (!isBrowser())
    return "";
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (const element of cookieArray) {
    let cookieValue = element;
    while (cookieValue.startsWith(" ")) {
      cookieValue = cookieValue.substring(1);
    }
    if (cookieValue.startsWith(name)) {
      return cookieValue.substring(name.length, cookieValue.length);
    }
  }
  return defaultValue ?? "";
};
const setCookie = (cookieName, cookieValue = "", domain, expireDays = 1) => {
  if (!isBrowser())
    return;
  const day = /* @__PURE__ */ new Date();
  day.setTime(day.getTime() + expireDays * TIME_CONFIG.SECONDS_IN_DAY);
  const expires = expireDays ? `expires=${day.toUTCString()}` : "";
  document.cookie = `${cookieName}=${cookieValue};domain=${domain};${expires};path=/`;
};
const removeCookie = (cookieName, domain) => {
  if (!isBrowser())
    return;
  document.cookie = `${cookieName}=deleted; path=/;domain=${domain};expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
const convertSecondsToDays = (seconds) => {
  return seconds / (60 * 60 * 24);
};

const setDefaultResponseConverter = (dataApiResponse, option) => {
  if (!dataApiResponse)
    return null;
  if (option?.formatResponse === FormatResponse.Custom) {
    return {
      option,
      data: dataApiResponse
    };
  } else if (option?.formatResponse === FormatResponse.Other) {
    const { responseMapping } = option;
    if (responseMapping && Object.keys(responseMapping).length > 0) {
      const data = {};
      for (const field of Object.keys(responseMapping || {})) {
        const valueField = responseMapping[field];
        data[field] = dataApiResponse[valueField];
      }
      return {
        option,
        ...data
      };
    } else {
      return {
        option,
        data: dataApiResponse
      };
    }
  } else if (option?.formatResponse === FormatResponse.Member) {
    const memberResponse = dataApiResponse;
    return {
      option,
      status: Number(memberResponse.result),
      statusText: memberResponse.message,
      data: memberResponse.value
    };
  } else {
    const defaultResponse = dataApiResponse;
    return {
      option,
      status: Number(defaultResponse.code),
      statusText: defaultResponse.message,
      data: defaultResponse.value
    };
  }
};

const isNull = (text) => {
  return text === void 0 || text === null;
};
const isEmpty = (text) => {
  return text.trim() === "";
};
const isNullOrEmpty = (text) => {
  return isNull(text) || isEmpty(text);
};
const isNumeric = (text) => {
  return !isNaN(parseFloat(text)) && !isNaN(Number(text)) && isFinite(parseFloat(text)) && isFinite(Number(text));
};

const EventBus = () => {
  const events = {};
  const on = (event, listener) => {
    if (!events[event]) {
      events[event] = [];
    }
    events[event].push(listener);
  };
  const emit = (event, data) => {
    if (events[event]) {
      events[event].forEach((listener) => listener(data));
    }
  };
  return {
    on,
    emit
  };
};

const getProperties = () => {
  return '["user_id","country_cd","person_verify_yn","parent_verify_yn"]';
};

const AuthHelper = (config) => {
  const removeAccessToken = () => {
    removeCookie(
      config.COOKIE_KEYS?.ACCESS_TOKEN || COOKIE_KEYS.ACCESS_TOKEN || "",
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN
    );
    removeCookie(COOKIE_KEYS.HEADER || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(COOKIE_KEYS.PAYLOAD || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(COOKIE_KEYS.SIGN || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(
      COOKIE_KEYS.ACCESS_EXPIRED_CHECK || "",
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN
    );
    removeCookie(COOKIE_KEYS.FOREVER || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(COOKIE_KEYS.OLD_REFRESH_TOKEN || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(COOKIE_KEYS.SGMC || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
    removeCookie(COOKIE_KEYS.REFRESH_TOKEN || "", config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN);
  };
  const setRefreshToken = (auth) => {
    const day = convertSecondsToDays(auth.expireIn || 0);
    const forever = getCookie(COOKIE_KEYS.FOREVER || "");
    setCookie(
      config.COOKIE_KEYS?.ACCESS_TOKEN || COOKIE_KEYS.ACCESS_TOKEN || "",
      auth.accessToken,
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN,
      0
    );
    setCookie(
      COOKIE_KEYS.REFRESH_TOKEN || "",
      auth.refreshToken,
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN,
      forever === DEFAULT_SUAT_EXPIRED_CHECK ? DEAUTL_EXPIRES_TIME_SURT : 0
    );
    setCookie(
      COOKIE_KEYS.OLD_REFRESH_TOKEN || "",
      auth.refreshToken,
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN,
      forever === DEFAULT_SUAT_EXPIRED_CHECK ? DEAUTL_EXPIRES_TIME_SURT : 0
    );
    setCookie(
      COOKIE_KEYS.ACCESS_EXPIRED_CHECK || "",
      DEFAULT_SUAT_EXPIRED_CHECK,
      config.DOMAIN || COOKIE_KEYS.COOKIE_DOMAIN,
      day
    );
  };
  return {
    removeAccessToken,
    setRefreshToken
  };
};

const AuthMapper = () => {
  const mappingFromRenewSession = (response) => {
    return {
      accessToken: response.access_token,
      refreshToken: response.refresh_token,
      memberNo: response.member.member_no,
      nickname: response.member.nickname,
      userId: response.member.user_id,
      countryCode: response.member.country_cd,
      personVerifyYn: response.member.person_verify_yn,
      parentVerifyYn: response.member.parent_verify_yn,
      loginCountryCode: response.login_country_cd,
      applicationNo: response.application_no,
      gameNo: response.game_no,
      expireIn: response.expire_in,
      providerCode: response.provider_cd,
      region: response.region
    };
  };
  return {
    mappingFromRenewSession
  };
};

const AuthService = (serviceFactory) => {
  const axiosService = () => {
    return serviceFactory.getService(ServiceKey.AxiosService);
  };
  const getConfig = () => {
    const configurationService = serviceFactory.getService(ServiceKey.ConfigurationService);
    return configurationService.getConfig();
  };
  const { mappingFromRenewSession } = AuthMapper();
  const { removeAccessToken, setRefreshToken } = AuthHelper(getConfig());
  const properties = getProperties();
  const auth = {
    accessToken: "",
    accessExpiredCheck: "",
    refreshToken: "",
    memberNo: 0,
    nickname: "",
    userId: "",
    countryCode: "",
    personVerifyYn: "",
    parentVerifyYn: ""
  };
  const authEventBus = EventBus();
  let initialToken = "";
  const setAuth = (authNewValue) => {
    auth.accessToken = authNewValue.accessToken;
    auth.refreshToken = authNewValue.refreshToken;
    auth.memberNo = authNewValue.memberNo;
    auth.nickname = authNewValue.nickname;
    auth.userId = authNewValue.userId;
    auth.countryCode = authNewValue.countryCode;
    auth.personVerifyYn = authNewValue.personVerifyYn;
    auth.parentVerifyYn = authNewValue.parentVerifyYn;
    auth.expireIn = authNewValue.expireIn;
    auth.accessExpiredCheck = "Y";
    initialToken = authNewValue.accessToken;
  };
  const setDefaultAuth = () => {
    auth.accessToken = "", auth.refreshToken = "", auth.memberNo = 0, auth.nickname = "", auth.userId = "", auth.countryCode = "", auth.personVerifyYn = "", auth.parentVerifyYn = "";
  };
  const authenticate = () => {
    return auth;
  };
  const getAccessToken = () => {
    return initialToken;
  };
  const getRefreshToken = () => {
    const COOKIE_NEW_REFRESHTOKEN = getCookie(COOKIE_KEYS.REFRESH_TOKEN || "");
    const COOKIE_BEFORE_REFRESHTOKEN = getCookie(COOKIE_KEYS.OLD_REFRESH_TOKEN || "");
    return auth.refreshToken || COOKIE_NEW_REFRESHTOKEN || COOKIE_BEFORE_REFRESHTOKEN;
  };
  const renewToken = async () => {
    const refreshToken = getRefreshToken() || "";
    if (!refreshToken) {
      setDefaultAuth();
      return null;
    }
    const resRenew = await renew(
      axiosService(),
      { refresh_token: refreshToken, properties },
      getConfig()
    );
    if (resRenew) {
      return mappingFromRenewSession(resRenew);
    }
    return null;
  };
  const checkRefreshToken = async () => {
    const authService = serviceFactory.getService(ServiceKey.AuthService);
    const newAuth = await authService.renewToken();
    if (newAuth) {
      setRefreshToken(newAuth);
      setAuth(newAuth);
      authEventBus.emit("authUpdated", newAuth);
      return auth;
    }
    removeAccessToken();
    setDefaultAuth();
    return null;
  };
  const isAuthentication = () => {
    return !!auth.accessToken && !!(auth.accessExpiredCheck && auth.accessExpiredCheck === "Y");
  };
  const authenticateByToken = async (accessToken, accessExpiredCheck, refreshToken) => {
    if (!refreshToken && !accessToken) {
      removeAccessToken();
      return false;
    }
    if (accessToken) {
      initialToken = accessToken;
      auth.refreshToken = refreshToken;
      auth.accessToken = accessToken;
      auth.accessExpiredCheck = accessExpiredCheck;
    }
    if (!accessToken || !(accessExpiredCheck === "Y")) {
      await checkRefreshToken();
    }
    return !!accessToken && accessExpiredCheck === "Y";
  };
  const getMemberInfo = async (queryProperties) => {
    const request = {
      properties: queryProperties || properties
    };
    const dataMember = await getMember(axiosService(), request, getConfig());
    if (dataMember) {
      const authNewValue = {
        ...auth,
        memberNo: dataMember?.member_no || 0,
        nickname: dataMember?.nickname || "",
        countryCode: dataMember?.country_cd || "",
        personVerifyYn: dataMember?.person_verify_yn || "",
        parentVerifyYn: dataMember?.parent_verify_yn || "",
        userId: dataMember?.user_id || ""
      };
      setAuth(authNewValue);
      authEventBus.emit("authUpdated", authNewValue);
      return dataMember;
    }
    return null;
  };
  const login = async (params, redirectCurrentPage = true) => {
    goLogin(params, redirectCurrentPage, getConfig());
  };
  const logout = (redirectUrl) => {
    goLogout(redirectUrl, getConfig());
    removeAccessToken();
  };
  return {
    getAccessToken,
    checkRefreshToken,
    login,
    logout,
    authenticate,
    authenticateByToken,
    isAuthentication,
    getMemberInfo,
    removeAccessToken,
    renewToken,
    authEventBus
  };
};

const API_TIME_CONFIG = {
  /** HA default timeout */
  HA_TIME_OUT: 5e3,
  /** Axios default cache time */
  CACHE_TIME: 1e3 * 60 * 30
};
const DEFAULT_TABLE_NAME = "api";
const DEFAULT_DB_NAME = "axios-cache";
const DEFAULT_CALLER_ID = "caller-id";

const BEARER = "Bearer";

const consoleLogError = (url, error, time) => {
  const errorShow = {
    From: "Server",
    ["Req time"]: `${time}s`,
    ["Req with url"]: url,
    ["Req body"]: error.config.data,
    ["Req with headers"]: error.config.headers,
    ["Res headers"]: error.response?.headers,
    ["Error status"]: error.response?.status,
    ["Error statusText"]: error.response?.statusText || error.message
  };
  if (process.server) {
    console.error(
      errorShow
    );
  } else {
    console.error({
      ...errorShow,
      From: "Client",
      ["Req with headers"]: JSON.stringify(error.config.headers),
      ["Res headers"]: JSON.stringify(error.response?.headers),
      ["Req body"]: JSON.stringify(error.config.data)
    });
  }
};

const AxiosService = (serviceFactory) => {
  const authService = () => serviceFactory?.getService(ServiceKey.AuthService);
  const getConfig = () => {
    const configurationService = () => serviceFactory?.getService(ServiceKey.ConfigurationService);
    return configurationService()?.getConfig();
  };
  const config = () => {
    if (serviceFactory) {
      return {
        COOKIE_KEYS: {
          ACCESS_TOKEN: getConfig().COOKIE_KEYS?.ACCESS_TOKEN || COOKIE_KEYS.ACCESS_TOKEN,
          ACCESS_EXPIRED_CHECK: getConfig().COOKIE_KEYS?.ACCESS_EXPIRED_CHECK || COOKIE_KEYS.ACCESS_EXPIRED_CHECK
        },
        ENABLE_CORS: getConfig().ENABLE_CORS || false,
        CACHE_DB_NAME: getConfig().CACHE_DB_NAME || DEFAULT_DB_NAME,
        CACHE_TABLE_NAME: getConfig().CACHE_TABLE_NAME || DEFAULT_TABLE_NAME,
        CALLER_ID: getConfig().CALLER_ID || DEFAULT_CALLER_ID
      };
    } else {
      return {
        COOKIE_KEYS: {
          ACCESS_TOKEN: COOKIE_KEYS.ACCESS_TOKEN,
          ACCESS_EXPIRED_CHECK: COOKIE_KEYS.ACCESS_EXPIRED_CHECK
        },
        ENABLE_CORS: false,
        CACHE_DB_NAME: DEFAULT_DB_NAME,
        CACHE_TABLE_NAME: DEFAULT_TABLE_NAME,
        CALLER_ID: DEFAULT_CALLER_ID
      };
    }
  };
  let commonHeader = {
    nation: "",
    timezone: "",
    utcOffset: null,
    lang: ""
  };
  const setCommonHeader = (cHeader) => {
    commonHeader = { ...cHeader };
  };
  const getCommonHeader = () => {
    return {
      ...commonHeader["x-forwarded-for"] ? { "x-forwarded-for": commonHeader["x-forwarded-for"] } : {},
      "X-Device-Type": "pc",
      "X-Nation": commonHeader.nation || GlobalDomain.DEFAULT_NATION,
      "X-Timezone": commonHeader.timezone || GlobalDomain.DEFAULT_TIMEZONE,
      "X-Utc-Offset": commonHeader.utcOffset || GlobalDomain.DEFAULT_UTC_OFFSET,
      "X-Lang": commonHeader.lang || GlobalDomain.DEFAULT_LOCALE,
      "X-Client-Lang": commonHeader.lang || GlobalDomain.DEFAULT_LOCALE
    };
  };
  const axiosNormal = axios.create();
  const getAccessToken = () => {
    const cookieClient = getCookie(config().COOKIE_KEYS?.ACCESS_EXPIRED_CHECK || "") && getCookie(config().COOKIE_KEYS?.ACCESS_TOKEN || "") ? getCookie(config().COOKIE_KEYS?.ACCESS_TOKEN || "") : "";
    return cookieClient || authService().getAccessToken();
  };
  const { axiosCache, axiosInstance, axiosCacheNoAuth } = useCacheRequest(
    config().CACHE_DB_NAME || "",
    config().CACHE_TABLE_NAME || ""
  );
  const axiosError = (err, url, response) => {
    const error = err;
    response.error = error;
    response.statusText = `${error.message}: ${url}`;
    response.status = error.response?.status;
    return response;
  };
  const requestHaApi = async (time, url, option) => {
    const haURL = `${option?.haInfo?.domain}${option?.haInfo?.url}`;
    const response = {
      option
    };
    try {
      const { data, status, statusText, headers } = await axiosNormal(haURL, {
        withCredentials: config().ENABLE_CORS,
        timeout: option?.haInfo?.maxAge,
        ...option
      });
      response.data = setDefaultResponseConverter(data, {
        ...option,
        url
      });
      return {
        ...response,
        status,
        statusText,
        headers
      };
    } catch (err) {
      consoleLogError(url, err, time);
      throw axiosError(err, haURL, response);
    }
  };
  const requestHaApiWithCache = async (time, url, option) => {
    const haURL = `${option?.haInfo?.domain}${option?.haInfo?.url}`;
    const response = {
      option
    };
    try {
      const { data, status, statusText, headers } = await (option?.isAuth ? axiosCache : axiosCacheNoAuth)(haURL, {
        withCredentials: config().ENABLE_CORS,
        timeout: option?.haInfo?.maxAge,
        ...option
      });
      response.data = setDefaultResponseConverter(data, {
        ...option,
        url
      });
      return {
        ...response,
        statusText,
        status,
        headers
      };
    } catch (err) {
      consoleLogError(url, err, time);
      throw axiosError(err, haURL, response);
    }
  };
  let isRefreshingRequestNormal = false;
  let pendingRequestsNormal = [];
  const requestNormal = async (url, option) => {
    const response = {
      option
    };
    const startTime = Date.now();
    if (option?.isAuth && getAccessToken()) {
      axiosNormal.interceptors.request.use((config2) => {
        config2.headers.Authorization = `${BEARER} ${getAccessToken()}`;
        return config2;
      });
    } else {
      axiosNormal.interceptors.request.clear();
    }
    axiosNormal.interceptors.response.use(
      async (config2) => {
        return config2;
      },
      async (error) => {
        const { response: response2, config: config2 } = error;
        const urlOriginal = config2?.url;
        if (response2?.status === ErrorCode.INVALID_TOKEN) {
          if (!isRefreshingRequestNormal) {
            isRefreshingRequestNormal = true;
            const newToken = await authService().checkRefreshToken();
            if (newToken) {
              isRefreshingRequestNormal = false;
              pendingRequestsNormal.forEach((callback) => callback(newToken));
              pendingRequestsNormal = [];
              const { data } = await requestNormal(urlOriginal, {
                ...config2,
                headers: {
                  ...config2?.headers,
                  Authorization: `${BEARER} ${newToken.accessToken}`
                },
                isRecall: true
              });
              return data;
            }
            isRefreshingRequestNormal = false;
            pendingRequestsNormal = [];
            return Promise.reject(error);
          }
          return new Promise((resolve) => {
            pendingRequestsNormal.push(async (newToken) => {
              const { data } = await requestNormal(urlOriginal, {
                ...config2,
                headers: {
                  ...config2?.headers,
                  Authorization: `${BEARER} ${newToken.accessToken}`
                },
                isRecall: true
              });
              if (data) {
                resolve(data);
              }
            });
          });
        }
        return Promise.reject(error);
      }
    );
    try {
      const result = await axiosNormal(url, {
        method: option?.method ?? "GET",
        withCredentials: config().ENABLE_CORS,
        ...option
      });
      const { data, status, statusText, headers } = result;
      if (option?.isRecall) {
        return {
          data: result,
          status,
          statusText,
          headers
        };
      }
      response.data = setDefaultResponseConverter(data, {
        ...option,
        url
      });
      return {
        ...response,
        status,
        statusText,
        headers
      };
    } catch (err) {
      const endTimeError = Date.now();
      const time = (endTimeError - startTime) / 1e3;
      if (option?.haUse) {
        return requestHaApi(time, url, option);
      } else {
        consoleLogError(url, err, time);
        throw axiosError(err, url, response);
      }
    }
  };
  const requestCache = async (url, option) => {
    const response = {
      option
    };
    const startTime = Date.now();
    axiosInstance.interceptors.request.use((config2) => {
      if (getAccessToken()) {
        config2.headers.Authorization = `${BEARER} ${getAccessToken()}`;
      }
      return config2;
    });
    try {
      axiosCache.defaults.cache.ttl = option?.cacheInfo?.maxAge ?? API_TIME_CONFIG.CACHE_TIME;
      axiosCacheNoAuth.defaults.cache.ttl = option?.cacheInfo?.maxAge ?? API_TIME_CONFIG.CACHE_TIME;
      const { data, status, statusText, headers } = await (option?.isAuth ? axiosCache : axiosCacheNoAuth)(url, {
        method: option?.method ?? "GET",
        withCredentials: config().ENABLE_CORS,
        timeout: option?.haUse ? API_TIME_CONFIG.HA_TIME_OUT : 0,
        // Default no timeout,
        ...option
      });
      response.data = setDefaultResponseConverter(data, {
        ...option,
        url
      });
      return {
        ...response,
        statusText,
        status,
        headers
      };
    } catch (err) {
      const endTimeError = Date.now();
      const time = (endTimeError - startTime) / 1e3;
      if (option?.haUse) {
        return requestHaApiWithCache(time, url, option);
      } else {
        consoleLogError(url, err, time);
        throw axiosError(err, url, response);
      }
    }
  };
  const createCallerHeaderData = () => {
    let callerDetail = null;
    try {
      if (window?.localStorage !== null) {
        callerDetail = window.localStorage.getItem(COOKIE_KEYS.UUID || "");
      }
      if (!callerDetail && navigator.cookieEnabled) {
        callerDetail = getCookie(COOKIE_KEYS.UUID || "");
      }
      return { "caller-id": config()?.CALLER_ID, "caller-detail": callerDetail };
    } catch (error) {
      return { "caller-id": config()?.CALLER_ID, "caller-detail": null };
    }
  };
  const request = async (url, option) => {
    if (!option?.method) {
      option = {
        ...option,
        method: "GET"
      };
    }
    return (option?.cacheInfo?.maxAge && getIndexedDB() && option.method === "GET" ? requestCache : requestNormal)(url, {
      ...option,
      headers: {
        ...getCommonHeader(),
        ...createCallerHeaderData(),
        ...option?.headers
      }
    });
  };
  const get = (url, option) => {
    const method = "GET";
    return request(url, { ...option, method });
  };
  const post = (url, option) => {
    const method = "POST";
    return request(url, { ...option, method });
  };
  const put = (url, option) => {
    const method = "PUT";
    return request(url, { ...option, method });
  };
  const patch = (url, option) => {
    const method = "PATCH";
    return request(url, { ...option, method });
  };
  const deleteFn = (url, option) => {
    const method = "DELETE";
    return request(url, { ...option, method });
  };
  const clearInterceptors = () => {
    if (typeof axios.interceptors.request.clear === "function") {
      axios.interceptors.request.clear();
    }
    if (typeof axiosInstance.interceptors.request.clear === "function") {
      axiosInstance.interceptors.request.clear();
    }
  };
  return {
    request,
    get,
    post,
    patch,
    put,
    deleteFn,
    clearInterceptors,
    setCommonHeader,
    getCommonHeader,
    commonHeader
  };
};

const total = async (request, axiosService, context, config) => {
  const { get } = axiosService;
  const { data } = await get(
    `${config.API_URL}/${context}/v2/client/policy/total`,
    {
      method: "get",
      params: request,
      formatResponse: FormatResponse.Other,
      responseMapping: gdsResponseMapping,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  );
  return data?.data || null;
};
const gdsResponseMapping = {
  status: "res_code",
  data: "res_data",
  statusText: "res_message"
};

const GlobalDomainMapper = () => {
  const mappingTotalGds = (response) => {
    return {
      nation: response.nation,
      lang: response.lang.toLowerCase(),
      locale: response.lang.toLowerCase(),
      timezone: response.timezone,
      utcOffset: String(response.utc_offset),
      isDefault: response.is_default,
      coverages: response.coverages,
      regulation: response.regulation.toUpperCase()
    };
  };
  return {
    mappingTotalGds
  };
};

const GlobalDomainHelper = (getConfig) => {
  const getCoveragesToString = (coverages) => {
    return (Array.isArray(coverages) ? coverages : []).join(",");
  };
  const setGdsInfoToCookie = (globalDomain) => {
    const domain = getConfig().DOMAIN;
    setCookie(COOKIE_KEYS.LANGUAGE || "", globalDomain.lang, domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(COOKIE_KEYS.COUNTRY || "", globalDomain.nation, domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(COOKIE_KEYS.TIMEZONE || "", globalDomain.timezone, domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(COOKIE_KEYS.UTC_OFFSET || "", globalDomain.utcOffset, domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(COOKIE_KEYS.REGULATION || "", globalDomain.regulation, domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(COOKIE_KEYS.LOCALE || "", globalDomain.locale.toUpperCase(), domain || COOKIE_KEYS.COOKIE_DOMAIN);
    setCookie(
      COOKIE_KEYS.COVERAGES || "",
      getCoveragesToString(globalDomain.coverages),
      domain || COOKIE_KEYS.COOKIE_DOMAIN
    );
  };
  const checkInvalidateGdsData = (gdsData) => {
    return isNullOrEmpty(gdsData.nation) || isNullOrEmpty(gdsData.lang) || isNullOrEmpty(gdsData.timezone) || !isNumeric(String(gdsData.utc_offset));
  };
  const retrieveTotalGds = async (axiosService) => {
    const BASE_SITE = "onstove";
    const context = "gds";
    const commonHeader = axiosService.getCommonHeader();
    const clientLang = commonHeader["X-Lang"] || GlobalDomain.DEFAULT_LANGUAGE;
    const { mappingTotalGds } = GlobalDomainMapper();
    const data = await total(
      {
        policy_grp: BASE_SITE,
        client_lang: clientLang,
        include_coverages: true
      },
      axiosService,
      context,
      getConfig()
    );
    if (data) {
      if (checkInvalidateGdsData(data)) {
        throw new Error("Invalidate gds data");
      }
      const commonHeader2 = {
        nation: data.nation,
        lang: data.lang,
        timezone: data.timezone,
        utcOffset: data.utc_offset
      };
      axiosService.setCommonHeader(commonHeader2);
      return mappingTotalGds(data);
    }
  };
  return {
    getCoveragesToString,
    setGdsInfoToCookie,
    retrieveTotalGds
  };
};

const GdService = (serviceFactory) => {
  const axiosService = () => serviceFactory.getService(ServiceKey.AxiosService);
  const getConfig = () => {
    const configurationService = serviceFactory.getService(ServiceKey.ConfigurationService);
    return configurationService.getConfig();
  };
  const globalDomain = {
    isDefault: false,
    nation: "",
    lang: "",
    timezone: "",
    utcOffset: "",
    locale: "",
    coverages: [],
    regulation: "",
    clientLang: "",
    exceptionLocale: ""
  };
  const setGlobalDomain = (newGlobalDomainValue) => {
    globalDomain.isDefault = newGlobalDomainValue.isDefault;
    globalDomain.nation = newGlobalDomainValue.nation;
    globalDomain.lang = newGlobalDomainValue.lang;
    globalDomain.timezone = newGlobalDomainValue.timezone;
    globalDomain.utcOffset = newGlobalDomainValue.utcOffset;
    globalDomain.locale = newGlobalDomainValue.locale;
    globalDomain.coverages = newGlobalDomainValue.coverages;
    globalDomain.clientLang = newGlobalDomainValue.clientLang;
    globalDomain.exceptionLocale = newGlobalDomainValue.exceptionLocale;
  };
  const getGlobalDomainData = async () => {
    const { setGdsInfoToCookie, retrieveTotalGds } = GlobalDomainHelper(getConfig);
    const newGlobalDomain = await retrieveTotalGds(axiosService(), getConfig);
    if (newGlobalDomain) {
      setGlobalDomain(newGlobalDomain);
      setGdsInfoToCookie(newGlobalDomain);
      return Promise.resolve(newGlobalDomain);
    }
    return Promise.resolve(globalDomain);
  };
  return {
    globalDomain,
    getGlobalDomainData
  };
};

const AxiosServer = (runtypeConfig) => {
  let accessToken = "";
  let config = {
    COOKIE_KEYS: {
      ACCESS_TOKEN: COOKIE_KEYS.ACCESS_TOKEN
    },
    ENABLE_CORS: false,
    CACHE_DB_NAME: DEFAULT_DB_NAME,
    CACHE_TABLE_NAME: DEFAULT_TABLE_NAME,
    CALLER_ID: DEFAULT_CALLER_ID
  };
  const axiosServer = axios.create();
  let commonHeader = {
    nation: "",
    timezone: "",
    utcOffset: null,
    lang: ""
  };
  const setCommonHeader = (cHeader) => {
    commonHeader = { ...cHeader };
  };
  const getCommonHeader = () => {
    return {
      ...commonHeader,
      "X-Device-Type": "pc",
      "X-Nation": commonHeader.nation || GlobalDomain.DEFAULT_REGULATION,
      "X-Timezone": commonHeader.timezone || GlobalDomain.DEFAULT_TIMEZONE,
      "X-Utc-Offset": commonHeader.utcOffset || GlobalDomain.DEFAULT_UTC_OFFSET,
      "X-Lang": commonHeader.lang || GlobalDomain.DEFAULT_LOCALE,
      "X-Client-Lang": commonHeader.lang || GlobalDomain.DEFAULT_LOCALE
    };
  };
  if (runtypeConfig) {
    config = {
      COOKIE_KEYS: {
        ACCESS_TOKEN: runtypeConfig.COOKIE_KEYS?.ACCESS_TOKEN || COOKIE_KEYS.ACCESS_TOKEN
      },
      ENABLE_CORS: runtypeConfig.ENABLE_CORS || false,
      CALLER_ID: runtypeConfig?.CALLER_ID || DEFAULT_CALLER_ID
    };
  }
  const setAccessToken = (token) => {
    accessToken = token;
  };
  const axiosError = (err, url, response) => {
    const error = err;
    response.error = error;
    response.statusText = `${error.message}: ${url}`;
    response.status = error.response?.status;
    return response;
  };
  const request = async (url, option) => {
    return requestNormal(url, {
      ...option,
      headers: {
        ...getCommonHeader(),
        ...createCallerHeaderData(),
        ...option?.headers
      }
    });
  };
  const requestNormal = async (url, option) => {
    const startTime = Date.now();
    const response = {
      option
    };
    axiosServer.interceptors.request.use((config2) => {
      if (accessToken) {
        config2.headers.Authorization = `${BEARER} ${accessToken}`;
      }
      return config2;
    });
    try {
      const { data, status, statusText, headers } = await axiosServer(url, {
        ...option,
        method: option?.method ?? "GET",
        withCredentials: config.ENABLE_CORS,
        timeout: option?.haUse ? API_TIME_CONFIG.HA_TIME_OUT : 0
        // Default no timeout
      });
      response.data = setDefaultResponseConverter(data, {
        ...option,
        url
      });
      response.statusText = statusText;
      response.status = status;
      response.headers = headers;
    } catch (err) {
      const endTimeError = Date.now();
      const time = (endTimeError - startTime) / 1e3;
      if (option?.haUse) {
        const haURL = `${option.haInfo?.domain}${option.haInfo?.url}`;
        try {
          const { data, status, statusText, headers } = await axiosServer(haURL, {
            ...option,
            withCredentials: config.ENABLE_CORS,
            timeout: option.haInfo?.maxAge
          });
          response.data = setDefaultResponseConverter(data, {
            ...option,
            url
          });
          response.statusText = statusText;
          response.status = status;
          response.headers = headers;
        } catch (err2) {
          consoleLogError(url, err2, time);
          throw axiosError(err2, haURL, response);
        }
      } else {
        consoleLogError(url, err, time);
        throw axiosError(err, url, response);
      }
    }
    return response;
  };
  const createCallerHeaderData = () => {
    let callerDetail = null;
    try {
      if (window?.localStorage !== null) {
        callerDetail = window.localStorage.getItem(COOKIE_KEYS.UUID || "");
      }
      if (!callerDetail && navigator.cookieEnabled) {
        callerDetail = getCookie(COOKIE_KEYS.UUID || "");
      }
      return { "caller-id": config?.CALLER_ID, "caller-detail": callerDetail };
    } catch (error) {
      return { "caller-id": config?.CALLER_ID, "caller-detail": null };
    }
  };
  const get = (url, option) => {
    const method = "GET";
    return request(url, { ...option, method });
  };
  const post = (url, option) => {
    const method = "POST";
    return request(url, { ...option, method });
  };
  const put = (url, option) => {
    const method = "PUT";
    return request(url, { ...option, method });
  };
  const patch = (url, option) => {
    const method = "PATCH";
    return request(url, { ...option, method });
  };
  const deleteFn = (url, option) => {
    const method = "DELETE";
    return request(url, { ...option, method });
  };
  const clearInterceptors = () => {
    if (typeof axios.interceptors.request.clear === "function") {
      axios.interceptors.request.clear();
    }
  };
  return {
    request,
    get,
    post,
    patch,
    put,
    deleteFn,
    clearInterceptors,
    setAccessToken,
    setCommonHeader,
    getCommonHeader,
    commonHeader
  };
};

const SERVICES = [
  {
    key: ServiceKey.AuthService,
    service: AuthService
  },
  {
    key: ServiceKey.AxiosService,
    service: AxiosService
  },
  {
    key: ServiceKey.GdService,
    service: GdService
  }
];

const ConfigurationService = () => {
  let configuration = {
    AUTH_URL: "",
    SESSION_URL: "",
    MEMBER_URL: "",
    DOMAIN: "",
    API_URL: ""
  };
  const setConfig = (config) => {
    if (Object.keys(config).length > 0) {
      configuration = config;
    }
  };
  const getConfig = () => {
    return configuration;
  };
  return {
    getConfig,
    setConfig
  };
};

const ServiceFactory = () => {
  const services = /* @__PURE__ */ new Map();
  const getService = (key) => {
    const service = services.get(key);
    if (!service) {
      throw new Error(`Service ${key} not found.`);
    }
    return service;
  };
  const registerService = (key, service, isOverride = false) => {
    if (services.has(key) && !isOverride) {
      throw new Error(`Service ${key} is already registered.`);
    }
    services.set(key, service);
  };
  return {
    services,
    getService,
    registerService
  };
};

const UseContext = async (configuration) => {
  const serviceFactory = ServiceFactory();
  const { registerService, getService } = serviceFactory;
  const configurationService = ConfigurationService();
  const { setConfig } = configurationService;
  setConfig(configuration);
  registerService(ServiceKey.ConfigurationService, configurationService);
  for (const service of SERVICES) {
    registerService(service.key, service.service(serviceFactory));
  }
  return {
    configurationService,
    authService: getService(ServiceKey.AuthService),
    axiosService: getService(ServiceKey.AxiosService),
    gdService: getService(ServiceKey.GdService),
    serviceFactory
  };
};

export { AxiosServer, AxiosService, COOKIE_KEYS, DEAUTL_EXPIRES_TIME_SURT, DEFAULT_CHECK_REFRESH_TOKEN, DEFAULT_SUAT_EXPIRED_CHECK, DependencyInjectId, ErrorCode, FormatResponse, GlobalDomain, ServiceKey, UseContext, useCacheRequest };
//# sourceMappingURL=main.es.js.map
